import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { SharedService } from "./../../shared/shared.service";
import { DevoteeDetail } from "./../../devotee/devotee-detail";
import { PagingGridData } from "./../models/paging-grid-data";
import { VarifyOTPResponse } from '../../shared/varify-otp-response';

@Injectable()
export class AdminDevoteeService {


  constructor(private _http: HttpClient
    , private sharedService: SharedService) {
  }


  ServiceUrl: string = SharedService.BaseServiceUrl + "admin";

  // For Admin Authentication
  httpOptions = {
    headers: new HttpHeaders({
      'Authorization': 'Basic ' + this.sharedService.getAdminTokenAtLocStorage()
    })
  };


  public saveDevotee(devoteeDetail: DevoteeDetail): Observable<string> {
    let saveUrl = this.ServiceUrl + "/devotee/add";
    return this._http.post<string>(saveUrl, devoteeDetail)
  }

  public updateDevotee(devoteeDetail: DevoteeDetail): Observable<string> {
    let putUrl = this.ServiceUrl + "/devotee/update";
    return this._http.post<string>(putUrl, devoteeDetail);
  }

  public getDevotee(): Observable<DevoteeDetail[]> {
    return this._http.get<DevoteeDetail[]>(this.ServiceUrl, this.httpOptions);
  }

  public getEntity(id: number): Observable<DevoteeDetail> {

    let url = this.ServiceUrl + "/" + id;

    //let paramData = new HttpParams().set("id", id.toString());
    return this._http.get<DevoteeDetail>(url, this.httpOptions);
  }

  public getByMobileNo(mobileNo: string): Observable<any> {
    let getbyMobileUrl = this.ServiceUrl + "/devotees?MobileNo=" + mobileNo;
    return this._http.get<any>(getbyMobileUrl);
  }



  public searchDevotee(searchGridEntity: any): Observable<PagingGridData> {
    let searchUrl = SharedService.BaseServiceUrl + "admin/devotees";

    let params = new HttpParams();
    for (let key in searchGridEntity) {
      if (searchGridEntity.hasOwnProperty(key) && searchGridEntity[key] !== null) {
      params = params.set(key, searchGridEntity[key]);
      }
    }

    let searchUrlWithQueryString = searchUrl + "?" + params.toString();

    return this._http.get<PagingGridData>(searchUrlWithQueryString);
  }

  public searchDevoteeForPrint(searchGridEntity: any): Observable<DevoteeDetail[]> {
    let searchUrl = this.ServiceUrl + "/SearchDevoteeForPrint";
    return this._http.post<DevoteeDetail[]>(searchUrl, searchGridEntity, this.httpOptions);
  }

  public searchAdminDevoteeAddPrint(searchGridEntity: any): Observable<DevoteeDetail[]> {
    let searchUrl = SharedService.BaseServiceUrl + "admin/devotees/address/print";

    let params = new HttpParams();
    for (let key in searchGridEntity) {
      if (searchGridEntity.hasOwnProperty(key) && searchGridEntity[key] !== null) {
      params = params.set(key, searchGridEntity[key]);
      }
    }

    let searchUrlWithQueryString = searchUrl + "?" + params.toString();

    return this._http.get<DevoteeDetail[]>(searchUrlWithQueryString);
  }

  public loadKiteData(): Observable<string> {
    let searchUrl = "https://kite.zerodha.com/oms/instruments/historical/256265/60minute?user_id=YL4741&oi=1&from=2022-09-23&to=2022-12-25";

    var httpOptionsKite = {
      headers: new HttpHeaders({
        'authorization': 'enctoken 8TuXU20aL94gm/30RsLUwkxvMfGEWcTdagC0/NdqZIWR0tulQT/Lf9VV7r/E7gWr02MpTKnNT8Gd8GFgLMIoJ7I3xGhvT/kZWQY/+v3+cbtsJhbT0aeu5g=='
      })
    }


    return this._http.get<string>(searchUrl, httpOptionsKite);
  }

  public verifyAdminToken(tokenNo: string): Observable<boolean> {
    let loginHttpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Basic ' + tokenNo
      })
    };
    let url = this.ServiceUrl + "/VarifyAdminToken/" + tokenNo;
    console.log(loginHttpOptions);
    return this._http.get<boolean>(url, loginHttpOptions);
  }

  public sendOTP(mobileNo: string): Observable<string> {
    let getbyMobileUrl = SharedService.BaseServiceUrl + "Auth/request-otp";
    let request: any = {
      MobileNo: mobileNo.toString(),
      Platform: 'AdminWebApp'
    }
    return this._http.post<string>(getbyMobileUrl, request);
  }

  public varifyOTP(mobileNo: string, otp: string): Observable<VarifyOTPResponse> {
    let getbyMobileUrl = SharedService.BaseServiceUrl + "Auth/verify-otp";
    let request: any = {
      MobileNo: mobileNo.toString(),
      OTP: otp.toString(),
      DeviceId: 'AdminWebApp',
      Platform: 'AdminWebApp'
    }
    return this._http.post<VarifyOTPResponse>(getbyMobileUrl, request);
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/services/admin-devotee.service.ts